import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const KineticLines = ({ lines, className = "", lineClassName = "", baseDelay = 0.15, step = 0.12, animate = true }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          {...(animate
            ? { animate: { y: 0 } }
            : { whileInView: { y: 0 }, viewport: { once: true, margin: "-60px" } })}
          transition={{ duration: 1, delay: baseDelay + i * step, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs md:text-sm uppercase tracking-[0.3em] text-gold font-bold ${className}`}>{children}</p>
);
